import { Obj } from "@kizmann/pico-js";

export const MessageFormConfig = {};

Obj.set(MessageFormConfig, 'NFormItem:token_id', {
    props: {
        label: '@Token',
        prop: 'token_id',
        rules: ['required']
    },
});

Obj.set(MessageFormConfig, 'NFormItem:token_id.content.NSelect', {
    binds: {
        modelValue: {
            value: '$model.token_id', fallback: ''
        }
    },
    props: {
        options: '$scope.$root.tokens',
        optionsValue: '$value.id',
        optionsLabel: '$value.client',
    }
});

Obj.set(MessageFormConfig, 'NFormItem:channel', {
    props: {
        label: '@Channel',
        prop: 'channel',
        rules: ['required']
    },
});

Obj.set(MessageFormConfig, 'NFormItem:channel.content.NInput', {
    binds: {
        modelValue: {
            value: '$model.channel', fallback: ''
        }
    },
    props: {
        placeholder: '@Channel'
    }
});

Obj.set(MessageFormConfig, 'NFormItem:is_read', {
    props: {
        label: '@Read',
        prop: 'is_read',
    },
});

Obj.set(MessageFormConfig, 'NFormItem:is_read.content.NSwitch', {
    binds: {
        modelValue: {
            value: '$model.is_read', fallback: 0
        }
    },
    props: {
        onValue: 1,
        offValue: 0
    },
    content: '@Message is read',
});

Obj.set(MessageFormConfig, 'NFormItem:message', {
    props: {
        label: '@Message',
        prop: 'body.message',
        rules: ['required']
    },
});

Obj.set(MessageFormConfig, 'NFormItem:message.content.NTextarea', {
    binds: {
        modelValue: {
            value: '$model.body.message', fallback: ''
        }
    },
    props: {
        autoRows: true,
        maxRows: 6,
        placeholder: '@Message'
    }
});

export default MessageFormConfig;